import React from "react";
import { Link } from "react-router-dom";

export default function VIPBanner() {
  return (
    <div className="bg-gradient-to-r from-purple-700 to-indigo-900 rounded-md shadow-lg p-3 text-white relative overflow-hidden border border-purple-400/30">
      {/* Sparkle effect in background */}
      <div className="absolute inset-0 bg-grid-white/5"></div>
      <div className="absolute -top-6 -right-6 w-12 h-12 rounded-full bg-yellow-300/20 blur-xl"></div>
      <div className="absolute -bottom-4 -left-4 w-16 h-16 rounded-full bg-purple-400/20 blur-xl"></div>

      {/* Banner content */}
      <div className="flex items-center justify-between gap-3 relative z-10">
        <div className="flex items-center space-x-3">
          {/* VIP Icon */}
          <div className="hidden sm:flex items-center justify-center w-10 h-10 bg-gradient-to-br from-yellow-300 to-yellow-500 rounded-full shadow-lg">
            <span className="text-purple-900 font-bold text-xs">VIP</span>
          </div>

          {/* Text content */}
          <div>
            <div className="flex items-center">
              <span className="text-yellow-300 mr-1 sm:hidden">👑</span>
              <h3 className="font-bold text-sm sm:text-base">
                ¡Desbloquea beneficios VIP!
              </h3>
            </div>

            <div className="flex flex-wrap text-xs text-gray-200 mt-1">
              <div className="flex items-center mr-3">
                <span className="text-green-300 mr-1">✓</span>
                <span>Pronósticos premium</span>
              </div>
              <div className="flex items-center mr-3">
                <span className="text-green-300 mr-1">✓</span>
                <span>Reto escaleras VIP</span>
              </div>
              <div className="flex items-center">
                <span className="text-green-300 mr-1">✓</span>
                <span>Soporte 24/7</span>
              </div>
            </div>
          </div>
        </div>

        {/* Link Button */}
        <Link
          to="/payment"
          className="shrink-0 bg-gradient-to-r from-yellow-400 to-amber-500 hover:from-yellow-300 hover:to-amber-400 text-purple-900 text-xs font-bold py-2 px-4 rounded-md shadow-md transition-all duration-200 flex items-center no-underline"
        >
          <span>Actualizar</span>
          <span className="ml-1">→</span>
        </Link>
      </div>
    </div>
  );
}
